<script setup lang="ts">
import BaseHeader__Builder from '~/components/BaseHeader__Builder'
import BaseCarousel__Builder from '~/components/BaseCarousel__Builder'
import BaseAccordion__Builder from '~/components/BaseAccordion__Builder'
import BaseTabViewHeroLike__Builder from '~/components/BaseTabViewHeroLike__Builder'
import FormContactUs__Builder from '~/components/FormContactUs__Builder'

const { data: builderContent } = await useBuilderPage()
</script>

<template>
  <BaseBuilderWrapper
    :content="builderContent"
    :components="[
      BaseHeader__Builder,
      BaseCarousel__Builder,
      BaseAccordion__Builder,
      BaseTabViewHeroLike__Builder,
      FormContactUs__Builder,
    ]"
  />
</template>
